import * as React from "react";
import './Intro.css';
import './Pick.css';
import '../components/Typograph.css';
import AppHeader from '../components/AppHeader';
import AppFooter from '../components/AppFooter';

export default class Intro extends React.Component {
    render() {
        return (
            <div className="page">
                <AppHeader title="Introductie scherm"/>

                <div className="page-middle">
                    <h1 className="welcome-title">Een productlijst voor uw situatie.</h1>
                    <p className="welcome-text">
                        Hier helpen we u met het bij elkaar zoeken van uw bestelling.<br/>
                        Momenteel is dit alleen mogelijk voor muurmontage.<br/>
                    </p>
                    <p className="detail-welcome-text">
                        Wilt u advies over de benodigde artikelen,<br/> gaat u de luiken op het kozijn monteren of <br/>komt u niet uit met het standaard beslag?<br/><br/>
                        Dan kunt u de <a href="/help/offerte-aanvraag">offerte aanvraag</a> gebruiken.<br/>
                        In dat geval krijgt u een vrijblijvend advies via de mail.
                    </p>
                    <p className="detail-welcome-text-bottom">
                        Klik op de knop hieronder om door te gaan.
                    </p>
                </div>

                <AppFooter onNext={this.props.handleNextPage}/>
            </div>
        );
    }
}